import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 8 8",
  xmlns: "http://www.w3.org/2000/svg",
  class: "modal_content__close-icon",
  "data-qa": "transaction-info-modal__close-button"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4.957 3.25l2.09 2.11c.156.143.156.286 0 .43l-.488.487c-.144.157-.287.157-.43 0l-2.11-2.09-2.109 2.09c-.143.157-.286.157-.43 0L.992 5.79c-.156-.143-.156-.286 0-.43l2.09-2.109-2.09-2.11C.836.998.836.855.992.71L1.48.224c.144-.157.287-.157.43 0l2.11 2.09L6.129.223c.143-.157.286-.157.43 0l.488.488c.156.143.156.286 0 .43L4.957 3.25z" }, null, -1 /* HOISTED */)
  ])))
}